module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope"
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Perfis")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Perfis',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid-maxlength ng-valid-minlength ng-valid-validate-unique ng-valid ng-valid-required",
    attrs: {
      "submit": _vm.onSubmit,
      "name": "frmRegProfileEntity",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome do perfil:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 255
      }),
      expression: "{required: true, max: 255}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.name),
      expression: "profile.name"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-isolate-scope ng-valid-maxlength ng-valid-minlength ng-valid-validate-unique ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    class: {
      'has-error': _vm.errors.first('status')
    },
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.active),
      expression: "profile.active"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.profile.active, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.profile, "active", true)
      }
    }
  }), _vm._v(" Sim\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.active),
      expression: "profile.active"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.profile.active, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.profile, "active", false)
      }
    }
  }), _vm._v(" Não\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.errors.first('status')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('status')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('descricao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Descrição do perfil:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.description),
      expression: "profile.description"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
    staticStyle: {
      "height": "150px"
    },
    attrs: {
      "name": "descricao",
      "required": ""
    },
    domProps: {
      "value": (_vm.profile.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('descricao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('descricao')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profile.id),
      expression: "profile.id"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "createdAt"
    }
  }, [_vm._v("Data criação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "createdAt",
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("moment")(_vm.profile.createdAt, 'DD/MM/YYYY HH:mm')
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "updatedAt"
    }
  }, [_vm._v("Data atualização:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "updatedAt",
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("moment")(_vm.profile.updatedAt, 'DD/MM/YYYY HH:mm')
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profile.id && _vm.profile.inactivateDateTime),
      expression: "profile.id && profile.inactivateDateTime"
    }],
    staticClass: "form-group ng-hide"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Data inativação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("moment")(_vm.profile.inactivateDateTime, 'DD/MM/YYYY HH:mm')
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSubmit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClean($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro de Perfil")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ff99bad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/perfis/EditarPerfil.vue
// module id = 2034
// module chunks = 1